import { TClusteredGroup } from "./types";


export default class CacheClusteredGroup {
    private cache: Map<string, TClusteredGroup>;
    
    constructor(){
        this.cache = new Map<string, TClusteredGroup>()
    }
    
    public get(key: string): TClusteredGroup {
        return this.cache.get(key)
    }

    public put (key: string, group: TClusteredGroup) {
        this.cache.set(key, group)
    }

    public getCache(): Map<string, TClusteredGroup>{
        return this.cache
    }
}